import usePost from './usePost';
import { useNotifyStore } from '@/store/useNotify';

const useNotify = () => {
    const { notify, setNotify } = useNotifyStore();
    const { PostMethod } = usePost();

    const getNotifyList = async () => {
        try {
            let response = await PostMethod({
                url: 'notify',
                method: 'get',
            });
            if (response?.success === true) {
                setNotify(response.data);
            } else {
                setNotify(null);
            }
        } catch (error) {
            console.error('Error fetching notify:', error);
        }
    };
    return {
        notify,
        setNotify,
        getNotifyList,
    };
};

export default useNotify;
